<template>
  <div search :class="{ on: searchMode, hasSearchData }">
    <div class="backdrop"></div>
    <a class="close" @click="close"></a>
    <div class="scroll-holder">
      <div class="sticky">
        <section class="search">
          <input id="searchInput" v-model="searchData" placeholder="Search" @keydown.prevent.enter="searchAct" @keyup="changeFontSize">
          <div class="quick" v-if="!hasSearchData">
            <label>I’m searching for</label>
            <ul>
              <li v-for="row in quickList" :key="row.code">
                <locale-link :to="row.data.route">{{ row.label }}</locale-link>
              </li>
            </ul>
          </div>
          <p class="result-txt" v-else>
            <span v-if="isEmpty(result)">No results found for “{{ searchWord }}”</span>
            <span v-else>{{ result.length }} results for “{{ searchWord }}”</span>
          </p>
        </section>
      </div>
      <template v-if="hasSearchData">
        <section class="result" v-if="!isEmpty(result)">
          <ul>
            <li v-for="(item, i) in result" :key="i">
              <a @click="linkTo(`/works/article/${item.slug}`)">
                <div class="img">
                  <cdn-img :src="item.image"/>
                </div>
                <div class="text">
                  <p>{{ item.title }}</p>
                  <p>{{ item.description }}</p>
                </div>
              </a>
            </li>
          </ul>
        </section>
      </template>
    </div>
  </div>
</template>


<script>
import _ from 'lodash';
import oax from '@/utils/oax';
import CdnImg from '@/views/components/CdnImg.vue';
import { sleep, values } from '@/utils';
import Vue from 'vue';

export default {
  name: 'Search',
  components: { CdnImg },
  data() {
    return {
      searchData: '',
      searchWord: '',
      quickList: null,
      currentFs: 0,
      result: null,
    };
  },
  watch: {
    async $route(to, from) {
      if (to.params.locale !== from.params.locale) {
        await this.getQuickLink();
      }
      this.reset();
    },
    matchedMedia() {
      this.changeFontSize();
    },
  },
  computed: {
    searchMode() {
      return this.$store.state.searchMode;
    },
    hasSearchData() {
      return this.$route.query.searchData;
    },
  },
  methods: {
    getFontSize() {
      if (this.matchedMedia in values('DX')) return 120;
      if (this.matchedMedia in values('DM', 'DL')) return 100;
      return 60;
    },
    changeFontSize() {
      const myInput = document.getElementById('searchInput');
      if (this.isOverflown(myInput)) {
        while (this.isOverflown(myInput)) {
          this.currentFs--;
          myInput.style.fontSize = this.currentFs + 'px';
        }
      } else {
        this.currentFs = this.getFontSize();
        myInput.style.fontSize = this.currentFs + 'px';
        while (this.isOverflown(myInput)) {
          this.currentFs--;
          myInput.style.fontSize = this.currentFs + 'px';
        }
      }
    },
    isOverflown(el) {
      return el.scrollWidth > el.clientWidth && this.currentFs > 8;
    },
    searchAct(e) {
      if (e?.isComposing) return;
      if (!this.searchData) {
        window.alert('검색어를 입력해주세요');
        return;
      }
      this.$router.push({ query: { searchData: this.searchData } });
    },
    async close() {
      this.$scroll.release();
      this.$store.commit('isFirst', false);
      this.$store.commit('searchMode', false);
      if (this.hasSearchData) this.$router.replace({ 'query': null });
      await sleep(500);
      this.searchData = '';
      this.result = null;
    },
    async getQuickLink() {
      const { data } = await oax.get(`/api/quickLink`, { lang: this.lang });
      const list = _.uniqBy(_.map(data, row => _.pickBy(row, _.identity)), 'priorityCategory').slice(0, 5);
      this.quickList = this.fullCodeList.filter(row => list.some(e => e.priorityCategory === row.code));
    },
    async getList() {
      this.result = (await oax.get('/api/article', { lang: this.lang, search: encodeURIComponent(this.searchData) })).data.list;
      this.searchWord = this.searchData;
    },
    reset() {
      console.log(123123123);
      this.searchData = this.$route.query.searchData;
      Vue.nextTick(() => {
        this.changeFontSize();
      });
      if (this.searchData) {
        this.$scroll.freeze();
        this.$scroll.scrollTo(0);
        this.$store.commit('searchMode', true);
        this.getList();
      } else {
        this.$scroll.release();
        this.$store.commit('searchMode', false);
      }
    },
  },
  mounted() {
    this.getQuickLink();
    this.reset();
  },
  beforeDestroy() {
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";
[search] { .abs; .lt; z-index: 999; .wf; .fvh; .-box; transform: translateX(-100%); transition: transform 0s; .tr-d(0s); color: #111;
  .first & {
    .backdrop, .close, section.search { transition-duration: 0s; .tr-d(0s); }
  }
  &.on { transform: translateX(0); transition: tranform 0s; .tr-d(0s);
    .backdrop, .close { .o(1); }
    .sticky { .o(1); .t-y(0); .tr-d(.3s); }
    .sticky:before { .o(1); .t-y(-100%); .tr-d(.3s); }
  }
  &.hasSearchData { background: #fff; }
  .scroll-holder { .rel; .f; overflow-y: auto; }
  .sticky { .sticky; .lt; z-index: 3; .mt(60); .o(0); .t-y(-10%); .tr-to(.4s);
    &:before { .cnt; .abs; .lt; .wh(100%,50vh); .bgc(#fff); .t-y(-100%); .o(0); .tr-to(.4s); }
  }
  .backdrop { .fix; .lt; .f; background: rgba(255, 255, 255, 0.9); .o(0); .tr-o(.4s); }
  .close { .block; .fix; .rt(20, 15); .wh(28); .contain('/img/common/ico-close-b.svg'); .o(0); .tr-o(.4s); z-index: 9; }
  section { .rel; .space-m; background: #fff;
    &.search { .pv(20);
      input { .block; .wf; .fs(60,1.2);
        &::placeholder { .c(#ccc); }
      }
      .quick { .pt(40);
        label { .block; .fs(12, 18); .c(#888); }
        ul { .mt(10);
          li { .ib; .mr(8); .mb(8);
            a { .block; .fs(14, 18); .p(8, 12); .-a(#ccc); text-decoration: none;
              .no-touch &:hover { .bgc(#111); .c(#fff); }
            }
          }
        }
      }
      .result-txt { .mt(32); .fs(18,28); }
    }
    &.result {
      > ul { .rel; .pv(20); .grid;
        > li {.rel; .mb(40);
          .img { aspect-ratio: 16 / 9; .crop; }
          [cdn-img] { .rel; .f; object-fit: cover; transform: scale(1); .o(1); transition: transform 1s cubic-bezier(0, 0, 0.13, 1.04), opacity .6s ease;}
          .text { .mt(20);
            p {.fs(24, 1); }
            p + p { .mt(20); .fs(16, 24, -0.25); }
          }
          &:last-of-type {.mb(0);}
          .no-touch &:hover {
            [cdn-img], video {transform: scale(1.1);}
            &.has-video [cdn-img] { .o(0); }
          }
        }
      }
    }
    &.no-list {.tc; .pt(108); .fs(16); .medium;}
  }
}
@media (min-width: @screen-tp-min) {
  [search] {
    section {
      &.result > ul > li {
        .text { display: grid; grid-template-columns: 1fr 1fr; column-gap: 10px;
          p + p { .mt(0); }
        }
      }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [search] {
    section {
      &.result {
        > ul { grid-template-columns: 1fr 1fr; column-gap: 20px;
          > li {
            .text { .block;
              p + p { .mt(10); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [search] {
    .close { .rt(40, 18); .wh(36); }
    .sticky { .mt(120); }
    section { .space-d;
      &.search {
        input { .fs(100, 1.2); }
        .result-txt { .mt(48); .fs(24,28); }
      }
      &.result {
        > ul { column-gap: 40px; .pv(55);
          > li {
            .text {
              p {.fs(28, 34); }
              p + p { .mt(10); .fs(18, 28, -0.25); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [search] {
    .close { .rt(40, 18); .wh(36); }
    .sticky { .mt(120); }
    section { .space-d;
      &.search {
        input { .fs(120); .h(120); }
        .result-txt { .mt(64); .fs(28,34); }
      }
      &.result {
        > ul { column-gap: 40px; .pv(55);
          > li {
            .text {
              p {.fs(28, 34); }
              p + p { .mt(10); .fs(18, 28, -0.25); }
            }
          }
        }
      }
    }
  }
}
</style>